module.exports = __webpack_public_path__ + "static/media/newshopify2.021e7b58.PNG";